// extracted by mini-css-extract-plugin
export default {"segmented":"NotificationsPage_segmented__hKl4o"};